import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCovermanager = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 32,
	viewBox: "0 0 30 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.56487 25.5534L6.46392 22.271V9.58503L9.57927 6.46968H23.0743L29.544 0H7.01962L0 7.01962V25.038L6.96203 32H29.5382L23.2183 25.5534H9.56487Z",
		fill: "#FFD028"
	})]
});
const ForwardRef = forwardRef(SvgCovermanager);
export { ForwardRef as ReactComponent };
